import React, { useState, useEffect } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"

import "./Product.css"

export const Product = (props) => {
    let timer

    const [remainTime, setRemainTime] = useState(0)
    const [isActive, setIsActive] = useState(false)
    const [backColor, setBackColor] = useState("transparent")
    const [foreColor, setForeColor] = useState("black")
    const [image, setImage] = useState("defaultproduct.jpg")
    const [expired, setExpired] = useState(false)

    const formatHour = (seconds) => {
        const hours = parseInt(seconds / 60)
        const minutes = parseInt(seconds - (hours * 60))

        return ("0" + hours).slice(-2) + "h" + ("0" + minutes).slice(-2) + "m"
    }

    useEffect(() => {
        if (props.product !== undefined) {
            setRemainTime(props.product.shelflifeTimer)
            setImage("url(" + (props.product.image !== null ? ("data:image/jpeg;base64," + props.product.image) : "../images/defaultproduct.jpg") + ")")
        }

        let index = props.levels.length

        document.documentElement.style.setProperty("--var-default-background", backColor)
        document.documentElement.style.setProperty("--var-default-foreground", foreColor)
        document.documentElement.style.setProperty("--var-expired-background", props.levels[index - 1].backgroundColor)
        document.documentElement.style.setProperty("--var-expired-foreground", props.levels[index - 1].foregroundColor)
    }, [])

    const updateTimer = () => {
        timer = !timer && setInterval(() => {
            if (!isActive || remainTime === 0)
                return;

            let invertRemainTime = props.product.shelflifeTimer - remainTime + 1
            if (invertRemainTime === props.product.shelflifeTimer)
                invertRemainTime = 999

            let level = props.levels.find(f => invertRemainTime >= f.min && invertRemainTime <= f.max)

            if (level !== undefined && (props.product.skipLevel != 0 || invertRemainTime === 999)) {
                setForeColor(level.foregroundColor)
                setBackColor(level.backgroundColor)

                if (invertRemainTime === 999)
                    setExpired(true)
            }

            setRemainTime(remainTime => remainTime - (remainTime !== 0 ? 1 : 0))
        }, process.env.REACT_APP_TICK_TIMEOUT * 1000);
    }

    useEffect(() => {
        updateTimer()

        return () => clearInterval(timer);
    }, [isActive, remainTime])

    function setAction(action) {

        if (action === "reset") {
            let level = props.levels[0]
            if (level !== undefined) {
                setForeColor(level.foregroundColor)
                setBackColor(level.backgroundColor)
            }

            setRemainTime(props.product.shelflifeTimer)
            setExpired(false)

            if (!isActive) {
                setIsActive(true)
                props.response(props.product.productId + ";enable")
            }

        } else if (action === "status") {
            setBackColor("transparent")
            setForeColor("black")
            setIsActive(!isActive)
            setExpired(false)

            props.response(props.product.productId + ";disable")
        }
    }
    
    return (
        <Card className="prod-card" onClick={() => setAction("reset")} onDoubleClick={() => setAction("status")}>
            <CardBody>
                <Row className="prod-card-rich" style={{ backgroundImage: image }} />
                <Row className="prod-card-footer">
                    <Col className={ expired ? "prod-card-expired" : null} style={{ color: foreColor, backgroundColor: backColor }}>
                        <div className="prod-card-name">
                            {props.product.productName}
                        </div>
                        <div className="prod-card-timer">
                            <span style={{ opacity: 0.6 }}>{formatHour(remainTime)}</span>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
